import { enCommon } from "@/i18n/locales/en-US/common";
import { enProduct } from "@/i18n/locales/en-US/product";
import { zhCommon } from "@/i18n/locales/zh-CN/common";
import { zhProduct } from "@/i18n/locales/zh-CN/product";

export const enResource = {
  ...enCommon,
  ...enProduct,
} as const;

export const zhResource = {
  ...zhCommon,
  ...zhProduct,
} as const satisfies Record<keyof typeof enResource, string>;

export const i18nResources = {
  "en-US": { translation: enResource },
  "zh-CN": { translation: zhResource },
} as const;

export type TranslationKey = keyof typeof enResource;
